<template>
  <div class="dashboard-container">
    <!-- 地图容器作为底层 -->
    <div class="map-layer">
      <MapComponent />
    </div>

    <!-- 快捷菜单按钮 -->
    <!-- <div class="quick-menu-container" @click.stop>
      <button class="menu-button" @click="toggleMenu">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
        </svg>
      </button>

      <div v-if="showMenu" class="dropdown-menu">
        <router-link to="/" class="menu-item" @click="closeMenu">
          <div class="menu-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
            </svg>
          </div>
          <span class="menu-text">首页</span>
        </router-link>

        <router-link to="/school-merge" class="menu-item" @click="closeMenu">
          <div class="menu-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </div>
          <span class="menu-text">撤并学校</span>
        </router-link>

        <router-link to="/add-school" class="menu-item" @click="closeMenu">
          <div class="menu-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            </svg>
          </div>
          <span class="menu-text">新增学校</span>
        </router-link>
      </div>
    </div> -->

    <!-- 右侧数据面板 -->
    <div class="right-panel">
      <!-- 一年级新生入学人数趋势图 -->
      <dv-border-box-12 class="chart-card">
        <div class="card-header">
          <h3>小学一年级招生人数趋势</h3>
        </div>
        <div class="chart-container">
          <PrimaryEnrollmentChart />
        </div>
      </dv-border-box-12>

      <!-- 七年级新生入学人数趋势图 -->
      <dv-border-box-12 class="chart-card">
        <div class="card-header">
          <h3>初中七年级招生人数趋势</h3>
        </div>
        <div class="chart-container">
          <MiddleEnrollmentChart />
        </div>
      </dv-border-box-12>

      <!-- 高一新生入学人数趋势图 -->
      <dv-border-box-12 class="chart-card">
        <div class="card-header">
          <h3>高中一年级招生人数趋势</h3>
        </div>
        <div class="chart-container">
          <HighEnrollmentChart />
        </div>
      </dv-border-box-12>
    </div>

    <!-- 左侧数据面板 -->
    <div class="left-panel">
      <!-- 出生人口统计图 -->
      <dv-border-box-12 class="chart-card">
        <div class="card-header">
          <h3>玉溪市2010-2030年出生人口统计</h3>
        </div>
        <div class="chart-container">
          <BirthPopulationChart />
        </div>
      </dv-border-box-12>

      <!-- 学校类型分布 -->
      <dv-border-box-12 class="chart-card">
        <div class="card-header">
          <h3>玉溪市2015-2035年各学段在校学生数</h3>
        </div>
        <div class="chart-container">
          <GradeNumberChart />
        </div>
      </dv-border-box-12>

      <!-- 区域学校统计 -->
      <dv-border-box-12 class="chart-card">
        <div class="card-header">
          <h3>玉溪市2015-2035年各学段教师人数</h3>
        </div>
        <div class="chart-container">
          <ClassNumberChart />
        </div>
      </dv-border-box-12>
    </div>

    <!-- 顶部标题 -->
    <!-- <div class="top-title">
      <dv-decoration-10 style="width: 100%; height: 5px" />
      <dv-decoration-8 :color="['#5680f9', '#000000']" style="width: 300px; height: 50px" />
      <div class="title-content">
        <dv-decoration-11 style="width: 500px; height: 60px">玉溪市教育数据可视化</dv-decoration-11>
      </div>
      <dv-decoration-8 :color="['#5680f9', '#000000']" :reverse="true" style="width: 300px; height: 50px" />
      <dv-decoration-10 style="width: 100%; height: 5px" />
    </div> -->

    <!-- 底部信息栏 -->
    <div class="bottom-info">
      <dv-decoration-10 style="width: 100%; height: 5px" />
      <div class="info-content">
        <span>数据更新时间：{{ currentTime }}</span>
        <span>玉溪市教育体育局 制</span>
      </div>
      <dv-decoration-10 style="width: 100%; height: 5px" />
    </div>
    <start></start>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import MapComponent from './yuxi.vue';
import Start from './start.vue';

// 导入图表组件
import PrimaryEnrollmentChart from './components/PrimaryEnrollmentChart.vue';
import MiddleEnrollmentChart from './components/MiddleEnrollmentChart.vue';
import HighEnrollmentChart from './components/HighEnrollmentChart.vue';
import BirthPopulationChart from './components/BirthPopulationChart.vue';
import GradeNumberChart from './components/GradeNumberChart.vue';
import ClassNumberChart from './components/ClassNumberChart.vue';

const currentTime = ref('');
const showMenu = ref(false);

// 更新时间
const updateTime = () => {
  const now = new Date();
  currentTime.value = now.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};

// 切换菜单显示状态
const toggleMenu = () => {
  showMenu.value = !showMenu.value;
};

// 关闭菜单
const closeMenu = () => {
  showMenu.value = false;
};

// 点击页面其他地方关闭菜单
const handleClickOutside = (event) => {
  const menuContainer = document.querySelector('.quick-menu-container');
  if (menuContainer && !menuContainer.contains(event.target)) {
    closeMenu();
  }
};

let timer = null;

onMounted(() => {
  updateTime();
  timer = setInterval(updateTime, 1000);

  // 添加全局点击事件监听
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  if (timer) {
    clearInterval(timer);
  }

  // 移除全局点击事件监听
  document.removeEventListener('click', handleClickOutside);
});
</script>

<style scoped>
.dashboard-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: linear-gradient(135deg, #0f1c3c 0%, #1a2b4d 100%);
}

.map-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

/* 快捷菜单按钮样式 */
.quick-menu-container {
  position: absolute;
  top: 5px;
  right: 10px;
  z-index: 300;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.menu-button {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background: rgba(16, 35, 70, 0.9);
  border: 1px solid rgba(64, 128, 255, 0.3);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.menu-button:hover {
  background: rgba(86, 128, 249, 0.2);
  border-color: #5680f9;
  transform: scale(1.05);
}

.menu-button svg {
  width: 24px;
  height: 24px;
}

.dropdown-menu {
  margin-top: 10px;
  width: 180px;
  background: rgba(16, 35, 70, 0.95);
  border-radius: 8px;
  border: 1px solid rgba(64, 128, 255, 0.3);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  backdrop-filter: blur(10px);
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  color: #fff;
  text-decoration: none;
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item:hover {
  background: rgba(86, 128, 249, 0.2);
  color: #5680f9;
}

.menu-icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-icon svg {
  width: 100%;
  height: 100%;
}

.menu-text {
  font-size: 14px;
  font-weight: 500;
}

.left-panel {
  position: absolute;
  left: 20px;
  top: 60px;
  width: 450px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.right-panel {
  position: absolute;
  right: 20px;
  top: 60px;
  width: 450px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.chart-card {
  width: 100%;
  height: 280px;
  background: rgba(16, 35, 70, 0.8);
  border-radius: 8px;
  backdrop-filter: blur(10px);
}

.card-header {
  padding: 15px 20px 10px;
  border-bottom: 1px solid rgba(64, 128, 255, 0.3);
}

.card-header h3 {
  margin: 0;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}

.chart-container {
  height: calc(100% - 50px);
  padding: 10px;
}

.top-title {
  position: absolute;
  top: 20px;
  left: 0;
  width: 100%;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 20px;
}

.title-content {
  padding: 0 30px;
  color: #fff;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  text-shadow: 0 0 10px rgba(86, 128, 249, 0.8);
}

.bottom-info {
  position: absolute;
  bottom: 10px;
  left: 0;
  width: 100%;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 20px;
}

.info-content {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  padding: 0 20px;
}

/* 响应式设计 */
@media (max-width: 1600px) {
  .left-panel,
  .right-panel {
    width: 400px;
  }

  .chart-card {
    height: 250px;
  }

  .quick-menu-container {
    right: 25px;
  }
}

@media (max-width: 1400px) {
  .left-panel,
  .right-panel {
    width: 350px;
  }

  .title-content {
    font-size: 24px;
  }

  .quick-menu-container {
    right: 20px;
  }
}

@media (max-width: 1200px) {
  .left-panel,
  .right-panel {
    width: 320px;
  }

  .chart-card {
    height: 230px;
  }

  .menu-button {
    width: 40px;
    height: 40px;
  }

  .dropdown-menu {
    width: 160px;
  }
}
</style>
